// Configuration for different environments
const config = {
  // API base URL - defaults to relative path for nginx proxy
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api/v1',
  
  // Debug mode
  DEBUG: process.env.NODE_ENV === 'development',
  
  // Timeout settings - увеличены для длительных операций анализа
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 600000, // 10 minutes
  QUICK_API_TIMEOUT: parseInt(process.env.REACT_APP_QUICK_API_TIMEOUT) || 30000, // 30 seconds
};

export default config;
